import createSaga from 'redux-saga';
import { all } from 'redux-saga/effects';

import AuthSaga from './auth.saga';
import ColorSaga from './color.saga';
import CustomerSaga from './customer.saga';
import InstallmentSaga from './installment.saga';
import OfficeSaga from './office.saga';
import PermissionSaga from './permission.saga';
import ProfileSaga from './profile.saga';
import PurchaseSaga from './purchase.saga';
import ReportSaga from './report.saga';
import RequestSaga from './request.saga';
import RoleSaga from './role.saga';
import SaleSaga from './sale.saga';
import StockSaga from './stock.saga';
import UserSaga from './user.saga';
import VehicleSaga from './vehicle.saga';

export function* sagas() {
  yield all([
    AuthSaga(),
    ColorSaga(),
    CustomerSaga(),
    InstallmentSaga(),
    OfficeSaga(),
    PermissionSaga(),
    ProfileSaga(),
    PurchaseSaga(),
    ReportSaga(),
    RequestSaga(),
    RoleSaga(),
    SaleSaga(),
    StockSaga(),
    UserSaga(),
    VehicleSaga(),
  ]);
}

const saga = createSaga();

export default saga;
